<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 text-center my-5">
                    <h3 class="heading">
                        Gallery 
                    </h3>
                    <hr class="custom-hr">
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <carousel-3d :autoplay="true" :autoplay-timeout="5000">
                        <slide :index="0">
                            <img src="../assets/images/galleries/13.jpg" alt="">
                        </slide>
                        <slide :index="1">
                            <img src="../assets/images/galleries/14.jpg" alt="">
                        </slide>
                        <slide :index="2">
                            <img src="../assets/images/galleries/15.jpg" alt="">
                        </slide>
                        <slide :index="3">
                            <img src="../assets/images/galleries/16.jpg" alt="">
                        </slide>
                        <slide :index="4">
                            <img src="../assets/images/galleries/17.jpg" alt="">
                        </slide>
                        <slide :index="5">
                            <img src="../assets/images/galleries/18.jpg" alt="">
                        </slide>
                    </carousel-3d>
                </div>
            </div>
        </div>
                    
    </div>
</template>

<script>
import { Carousel3d, Slide } from 'vue-carousel-3d';
export default {
    components: {
    Carousel3d,
    Slide
  }
}
</script>


<style>
.carousel-3d-slider {
    /* height: auto !important; */
    /* height: 430px !important; */
    /* width: 400px !important; */
    width: 562px !important;
    height: 100% !important;
    background-color: transparent !important;
}

.carousel-3d-container{
    height: 472px !important;

    /* height: 430px !important; */
}
.carousel-3d-slide{
    width: 100% !important;
    height: 100% !important;
    border-style: none !important;

}
.carousel-3d-slider img{
    height: 100% !important;
    width: 100% !important;
    object-fit: fill;
}

@media (max-width: 700px){
    .carousel-3d-container{
        height: 262px !important;
    }
    .carousel-3d-slider{
        width: 300px !important;
    }
}
</style>
